import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import LeftArrowTopHeader from "../../newComponents/form-fields/LeftArrowTopHeader";
import SimpleSpinner from "../../components/loader";
import LeaseApplication from "../../components/generatePdfDocument/leaseApplication";
import { useTenantData } from "../../tenantComponent/hooks/useTenantData";

const LeaseApplicationReviewView: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  // Early validation: no ID
  if (!id) {
    return (
      <div className="review-application-container">
        <LeftArrowTopHeader title="Review Application" backPath={-1} />
        <div className="error-message">
          <p>No application ID provided.</p>
        </div>
      </div>
    );
  }

  // Parse ID once
  const applicationId = Number(id);
  if (isNaN(applicationId)) {
    return (
      <div className="review-application-container">
        <LeftArrowTopHeader title="Review Application" backPath={-1} />
        <div className="error-message">
          <p>Invalid application ID.</p>
        </div>
      </div>
    );
  }

  const { tenantData, loading: tenantLoading } = useTenantData(applicationId);

  // Calculate back path once when tenantData is available
  const backPath = useMemo(() => {
    if (tenantData?.id && tenantData?.unitId) {
      return `/tenants/currenttenantdetails/${tenantData.id}/${tenantData.unitId}`;
    }
    return -1; // Fallback to browser back if data not ready
  }, [tenantData?.id, tenantData?.unitId]);

  // String version for LeaseApplication component
  const backPathString = typeof backPath === "string" ? backPath : undefined;

  // Show spinner while loading
  if (tenantLoading) {
    return (
      <div className="review-application-container">
        <LeftArrowTopHeader title="Review Application" backPath={backPath} />
        <div className="loading-container">
          <SimpleSpinner />
        </div>
      </div>
    );
  }

  // Main render when data is ready
  return (
    <div className="review-application-container content-wrapper full-page-content">
      <div className="review-content">
        <LeaseApplication tenantData={tenantData} path={backPathString} />
      </div>
    </div>
  );
};

export default LeaseApplicationReviewView;